import { redisGetHandler } from "../utils/redis";
import { isDraftSite } from "./draft";

const EMPTY_LIST = { data: [], total: 0, page: 1, limit: 28, totalPages: 0 };

export default (axios, config) => ({
  async getList(
    Redis = false,
    reset = false,
    { type = "news", page = 1, limit = 28 } = {},
  ) {
    const params = new URLSearchParams({
      type: String(type),
      page: String(page),
      limit: String(limit),
    });
    // Стенд видит черновики и ещё не опубликованные записи, прод — только опубликованные
    if (isDraftSite(config)) params.set("draft", "1");
    const path = `/news/list?${params.toString()}`;
    const data = await redisGetHandler(
      Redis,
      axios,
      config.SERVICE_DATABASE_API_URL,
      path,
      reset,
    );
    if (!data || typeof data !== "object") {
      return EMPTY_LIST;
    }
    if (Array.isArray(data)) {
      return {
        data,
        total: data.length,
        page: 1,
        limit: data.length,
        totalPages: data.length > 0 ? 1 : 0,
      };
    }
    return {
      data: Array.isArray(data.data) ? data.data : [],
      total: Number(data.total) || 0,
      page: Number(data.page) || 1,
      limit: Number(data.limit) || limit,
      totalPages: Number(data.totalPages) || 0,
    };
  },

  async getDetail(Redis = false, reset = false, { type = "news", code } = {}) {
    const params = new URLSearchParams({
      type: String(type),
      code: String(code ?? ""),
    });
    if (isDraftSite(config)) params.set("draft", "1");
    const path = `/news/detail?${params.toString()}`;
    const data = await redisGetHandler(
      Redis,
      axios,
      config.SERVICE_DATABASE_API_URL,
      path,
      reset,
    );
    return data && typeof data === "object" ? data : {};
  },
});
